'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MEDIA_ATTACHMENTS_QUERY_ROOT } from '@/hooks/mediaAttachments/queryKeys';
import { useFetch } from '@/hooks/useFetch';

export function useDeleteMediaAttachmentMutation() {
  const queryClient = useQueryClient();
  const { doFetch } = useFetch<void, void>();

  return useMutation({
    mutationFn: (uuid: string) =>
      doFetch(`/api/media-attachments/${encodeURIComponent(uuid)}`, {
        method: 'DELETE',
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [MEDIA_ATTACHMENTS_QUERY_ROOT] });
    },
  });
}
